(function(e){
	e.matches || (e.matches=e.matchesSelector||function(selector){
			var matches = document.querySelectorAll(selector), th = this;
			return Array.prototype.some.call(matches, function(e){
				return e === th;
			});
		});
})(Element.prototype);
(function() {

	// проверяем поддержку
	if (!Element.prototype.closest) {

		// реализуем
		Element.prototype.closest = function(css) {
			var node = this;

			while (node) {
				if (node.matches(css)) return node;
				else node = node.parentElement;
			}
			return null;
		};
	}

})();


//////////////////
// WEBPACK FOOTER
// ./frontend/js/polyfills.js
// module id = 6
// module chunks = 0